export default "__VITE_ASSET__BU8HN8pP__"